import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { pageMeta } from "@/lib/seo/meta";
import { TOOL_CACHE_HEADERS } from "@/lib/seo/headers";

const AddWatermarkView = lazy(() => import("@/features/add-watermark/view"));

export const Route = createFileRoute("/add-watermark")({
  head: () =>
    pageMeta({
      title: "Watermark a PDF",
      description:
        "Stamp text or an image on every page. Pick the position, opacity, and rotation.",
      path: "/add-watermark",
      keywords: "watermark pdf, stamp pdf, brand pdf, online, free",
    }),
  headers: () => TOOL_CACHE_HEADERS,
  component: () => (
    <Suspense fallback={null}>
      <AddWatermarkView />
    </Suspense>
  ),
});
